import GeneralInfo from "./GeneralInfo";
import PropTypes from "prop-types";

const GeneralInformation = ({ generalInfoData, loader, digitalIdentity }) => {
  return (
    <div style={{ padding: 20 }}>
      <GeneralInfo
        infoData={generalInfoData}
        loader={loader}
        digitalIdentity={digitalIdentity}
      />
    </div>
  );
};

GeneralInformation.propTypes = {
  generalInfoData: PropTypes.object,
  loader: PropTypes.bool,
  digitalIdentity: PropTypes.shape({
    controller_code: PropTypes.string,
    customer_scope: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
  }),
};

GeneralInformation.defaultProps = {
  generalInfoData: {},
  loader: false,
  digitalIdentity: null,
};

export default GeneralInformation;
